

export default {


    async SET_TOTAL_LEASE_ORDER(state, totalLeaseOrders) {
        state.totalLeaseOrders = totalLeaseOrders
    },
    async ADD_NEW_LEASE_ORDER(state, order) {
        state.leaseOrders.splice(0, 0, order) 
    },
    async SET_LEASE_ORDER(state, leaseOrders) {
        state.leaseOrders = leaseOrders
    },
    async UPDATE_LEASE_ORDER(state, order) {
        const leaseOrderIndex = state.leaseOrders.findIndex((p) => p.idOrder == order.idOrder)
        Object.assign(state.leaseOrders[leaseOrderIndex], order)
    },

    REMOVE_LEASE_ORDER(state, idOrder) {
        const leaseOrderIndex = state.leaseOrders.findIndex((p) => p.idOrder == idOrder)
        state.leaseOrders.splice(leaseOrderIndex, 1)

    },
    
    

}
 